/** Errors every applicable route may answer without declaring them in `errors`. */
export const IMPLICIT_ERRORS = Object.freeze([
    Object.freeze({ status: 400, code: 'invalid_request', scope: 'all' }),
    Object.freeze({ status: 401, code: 'unauthenticated', scope: 'session' }),
    Object.freeze({ status: 403, code: 'smoke_read_only', scope: 'smoke-deny' }),
    Object.freeze({ status: 403, code: 'reference_read_only', scope: 'reference-guarded' }),
    Object.freeze({ status: 403, code: 'origin_required', scope: 'api-mutation' }),
    Object.freeze({ status: 403, code: 'csrf_header_required', scope: 'api-mutation' }),
    Object.freeze({ status: 404, code: 'not_found', scope: 'all' }),
    Object.freeze({ status: 413, code: 'payload_too_large', scope: 'multipart' }),
    Object.freeze({ status: 415, code: 'unsupported_media_type', scope: 'multipart' }),
    Object.freeze({ status: 500, code: 'internal', scope: 'all' }),
    Object.freeze({ status: 500, code: 'response_contract_violation', scope: 'all' }),
]);
/** A non-GET route under `/api`, which the origin and CSRF-header checks cover. */
export function isApiMutation(route) {
    return route.method !== 'GET' && route.path.startsWith('/api/');
}
export function implicitErrorApplies(rule, route) {
    switch (rule.scope) {
        case 'all':
            return true;
        case 'session':
            return route.auth === 'session';
        case 'smoke-deny':
            return route.smoke === 'deny';
        case 'reference-guarded':
            return route.reference === 'deny' || route.reference === 'target-ok';
        case 'api-mutation':
            return isApiMutation(route);
        case 'multipart':
            return route.requestKind === 'multipart';
    }
}
/** Every (status, code) a route may answer: its own `errors` plus the implicit ones. */
export function declaredErrors(route) {
    const map = new Map();
    const add = (status, code) => {
        let codes = map.get(status);
        if (!codes) {
            codes = new Set();
            map.set(status, codes);
        }
        codes.add(code);
    };
    for (const [status, codes] of Object.entries(route.errors ?? {})) {
        for (const code of codes)
            add(Number(status), code);
    }
    for (const rule of IMPLICIT_ERRORS) {
        if (implicitErrorApplies(rule, route))
            add(rule.status, rule.code);
    }
    return map;
}
export function isDeclaredError(route, status, code) {
    return declaredErrors(route).get(status)?.has(code) ?? false;
}
//# sourceMappingURL=implicit-errors.js.map